if($(".extended-description table th:contains(FAQ)").length) {
  if($('#p-detail-tabs').length){
    $('#p-detail-tabs li').last().after('<li class="shp-tab faq" data-width=""><a href="#faq" class="shp-tab-link" role="tab" data-toggle="tab">Často kladené dotazy</a></li>')
    $('#tab-content.tab-content').append('<div id="faq" class="tab-pane fade" role="panel"></div>')    
  }
  if($('#accordion-content').length){
      $('#accordion-content').append('<div class="shp-accordion faq"><a href="#size" class="shp-accordion-link"><span>Často kladené dotazy</span></a><div class="shp-accordion-content"><div id="faq" class="tab-pane fade" role="panel"></div></div></div>')
  }
  $(".extended-description table th:contains(FAQ)").closest("tr").appendTo("#faq");
    $('#faq tr').each(function(){
        $(this).html('<div class="faq"><h3>'+$(this).find('td').text()+'</h3><p>'+$(this).find('.row-header-label span').attr('title')+'</p></div>')    
    })
  $('html').on('click', '.faq h3', function(){
    $(this).closest('.faq').toggleClass('open-it')
  })
}
